import React from 'react'
import Layout from '../../Layout'
import AllDeliveyRequestContainer from '../../../../Components/Deliver/AllDeliveyRequestContainer/AllDeliveyRequestContainer'

const AllDeliveryRequest = () => {
  return (
    <Layout><AllDeliveyRequestContainer/></Layout>
  )
}

export default AllDeliveryRequest